export default "__VITE_ASSET__DtJE5ScM__"